import toast from "react-hot-toast";
import { httpRequest } from "src/services/httpRequest";

// Get the use group
export const getUseGroup = async () => {
  const response = await httpRequest(
    'GET',
    `/useGroup/getAllUseGroup`
  );

  if (response?.status === 'success') {
    const UseGroupName = response?.data?.useGroups
      ?.map((value: { GroupName: string }) => {
        return value?.GroupName;
      })
      const UseGroupDescription = response?.data?.useGroups
      ?.map((value: { Description: string }) => {
        return value?.Description;
      })
    return [UseGroupName,UseGroupDescription];
  } else {
    toast.error(response?.message);
  }
};
